module.exports = __webpack_public_path__ + "img/NS-J-13.2c4f0e49.svg";